import styled from "styled-components";

export const Container = styled.div(({ theme }) => ({
    background: theme.colors[theme.colorMode].background_Secondary,
    marginTop: theme.spacing.medium,
}));

export const ContentContainer = styled.div(({ theme }) => ({
    overflowY: "auto",
    //this is to keep ui responsive and scrollable in case of keyboard issue for smaller devices
    maxHeight: "calc(100vh - var(--sat, 0px) + 148px)",
    background: theme.colors[theme.colorMode].background_Primary,
    margin: `0 ${theme.spacing.medium}`,
    boxShadow: theme.elevation[theme.colorMode].cards_And_Navigations.boxShadow,
    borderRadius: theme.cornerRadius.medium,
}));

export const ProceedContainer = styled.div(({ theme }) => ({
    position: "fixed",
    width: "100%",
    background: theme.colors[theme.colorMode].background_Primary,
    left: 0,
    bottom: 0,
    padding: theme.spacing.medium,
    paddingBottom: `calc(var(--sab, 0px) + ${theme.spacing.medium})`,
    "@supports (-webkit-touch-callout: none)": {
        "@supports (padding-bottom: env(safe-area-inset-bottom))": {
            paddingBottom: `calc(${theme.spacing.medium} + (env(safe-area-inset-bottom) / 2))`,
        },
    },
}));

export const OffersContainer = styled.div(({ theme }) => ({
    marginTop: theme.spacing.xxSmall,
    marginBottom: theme.spacing.large,
    ":empty": {
        display: "none",
    },
}));

export const Separator = styled.hr(({ theme }) => ({
    margin: `0px ${theme.spacing.medium}`,
    border: "none",
    borderTop: `1px solid ${theme.colors[theme.colorMode].border_Tertiary}`,
}));

export const OffersAmountContainer = styled.div(({ theme }) => ({
    background: theme.colors[theme.colorMode].background_Primary,
    margin: `${theme.spacing.xLarge} ${theme.spacing.medium} 0px`,
}));
